export default {
    SELECT_USER(state, user) {
        state.user = user;
    },
    SELECT_BPI(state, bpi) {
        state.bpi = bpi.forms;
        state.bpiId = bpi.id;
    },
    SELECT_BPI_OUTPUT(state, bpi) {
        state.bpi = bpi.bpi;
        // state.bpiId = bpi.id;
    },
    SET_BPI_ID(state, BPId) {
        state.bpiId = BPId;
    },
    SET_BPI_OUT_PUT(state, bpiOutPut) {
        state.bpiOutPut = bpiOutPut;
    },
    SET_CURRENT_STEP(state, path) {
        state.currentStep = path;
    },
    SET_BP_VERSION(state, version) {
        state.bpiVersion = version;
    }
};
